module.exports = __webpack_public_path__ + "img/sport-1.dc402ae4.jpg";